import React from "react";
import ClinicalBill from "../../components/manager/ClinicalBill";
import { PatientProfile, VisitRecord } from "./types";

interface BillingPanelProps {
    patient: PatientProfile | null;
    visit: VisitRecord | null;
}

export default function BillingPanel({ patient, visit }: BillingPanelProps) {
    const patientIdValue = patient?.patient_id != null ? String(patient.patient_id) : "";
    const visitIdValue = visit?.visit_id != null ? Number(visit.visit_id) : null;

    return (
        <div className="mod-standalone-window">
            {/* Modern Header Area */}
            <div className="mod-window-header">
                <div>
                    <h2 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        💳 Clinical Billing & Ledger
                    </h2>
                    <p className="mod-text-muted">Manage invoices, record payments, and track patient balances.</p>
                </div>
                
                {/* Contextual Badge */}
                {visitIdValue && (
                    <span 
                        className="mod-live-badge" 
                        style={{ 
                            background: 'var(--mod-surface)', 
                            color: 'var(--mod-sky)', 
                            border: '1px solid #bae6fd',
                            animation: 'none' // Override pulse for static badge
                        }}
                    >
                        Visit #{visitIdValue}
                    </span>
                )}
            </div>
            
            {/* Content Area */}
            <div className="mod-panel-content">
                {visitIdValue && patientIdValue ? (
                    <div className="mod-bill-wrapper" style={{ background: '#f8fafc', borderRadius: '12px', padding: '16px', border: '1px solid #e2e8f0' }}>
                        <ClinicalBill
                            patient={patient as any}
                            visit={visit as any}
                        />
                    </div>
                ) : (
                    /* Enhanced Empty State */
                    <div className="mod-empty-state" style={{ height: '320px', background: 'transparent', border: '1px dashed #cbd5e1' }}>
                        <div className="mod-empty-icon-wrapper" style={{ width: '64px', height: '64px', background: '#fef3c7', color: '#d97706' }}>
                            <span className="mod-empty-icon" style={{ fontSize: '1.8rem', opacity: 1 }}>🧾</span>
                        </div>
                        <h3 style={{ margin: '0 0 8px 0', fontSize: '1.1rem', color: 'var(--mod-text-main)' }}>
                            No Active Visit Selected
                        </h3>
                        <p style={{ margin: 0, fontSize: '0.9rem', color: 'var(--mod-text-muted)', maxWidth: '300px' }}>
                            Please start or select an active visit for this patient to view and manage clinical billing.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
}
